<script lang='ts'>
    import lang from '../../lang/language';
    import type {ServiceType} from '../../store/types';
    import {formatMoney} from '../../helpers/common';
    import AddToWishlistButton from '../../shared_components/AddToWishlistButton.svelte';
    import {currentLangIsJapanese, getDetailsUrl} from '../../helpers/url';
    import Link from "../../shared_components/controls/Link.svelte";
    import Button from "../../shared_components/controls/Button.svelte";

    export let service: ServiceType;

    const getTypeName = (type: number = 0) => {
        const serviceTypes = {
            '0': lang.accommodation,
            '1': lang.activity,
            '2': lang.restaurant,
            '3': lang.produce
        };

        return serviceTypes[`${type}`];
    }

</script>

<div class='card-wrapper'>
    <div class='like-button-wrapper'>
    </div>
    <div class='thumb-wrapper'>
        <img src={service.Thumbnail} alt='service thumbnail'>
    </div>
    <div class={`type-label type-${service.Type}`}>
        {getTypeName(service.Type)}
    </div>
    <div class='info name'>{service.Name}</div>
    <div class='info address'><i class="icon fa fa-map-marker-alt"></i>{service.Address}</div>
    <div class='info desc'>{service.Desc}</div>
    <div class='info price'>
        <span>
            {!currentLangIsJapanese() && service.Price > 0 ? lang.from : ''}
            ¥{formatMoney(service.Price)}
            {currentLangIsJapanese() && service.Price > 0 ? lang.from : ''}
        </span>
    </div>
    <div class='row-button flex-end'>
        <AddToWishlistButton service={service}/>
        <Link href={getDetailsUrl(service.Id)}
              secondary
              maxWidth='150px'
        >
            {lang.view_details}
        </Link>
    </div>
</div>

<style>
    :global(.type-label) {
        font-size: .9rem;
        padding: 5px 7px 7px 7px;
        position: absolute;
        top: 43.9%;
        left: 5px;
        color: white;
        text-transform: capitalize;
    }

    :global(.type-label.type-0) {
        background-color: maroon;
    }

    :global(.type-label.type-1) {
        background-color: darkolivegreen;
    }

    :global(.type-label.type-2) {
        background-color: lightcoral;
    }

    :global(.type-label.type-3) {
        background-color: saddlebrown;
    }

    :global(.card-wrapper) {
        background-color: transparent;
        padding: 5px;
        display: flex;
        flex-direction: column;
        margin-bottom: 40px;
        position: relative;
    }

    :global(.thumb-wrapper) {
        /*position: relative;*/
        border: 1px solid lightgray;
        width: 100%;
        height: 260px;
        margin-bottom: 20px;
        background-color: black;
    }

    :global(.thumb-wrapper) > :global(img) {
        background-color: black;
        height: 100%;
        width: 100%;
        object-fit: cover;
    }

    :global(.info) {
        margin: 5px 0px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        height: 27px;
        line-height: 27px;
        color: black;
        text-align: left;
    }

    :global(.info.name) {
        /*font-weight: bold;*/
        font-size: 20px;
        margin: 20px 0px;
    }

    :global(.info.desc) {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        height: 80px;
        font-size: 1rem;
        line-height: 28px;
        color: var(--grey-font);
    }

    :global(.info.address) {
        /*padding-left: 15px;*/
    }

    :global(.row-button) {
        display: flex;
        width: 100%;
        text-align: center;
        justify-content: flex-end;
        overflow: hidden;
        height: auto;
        padding: 0px 10px;
    }

    :global(.card-wrapper) a {
        text-decoration: none;
    }

    :global(.like-button-wrapper) {
        position: absolute;
        top: 15px;
        right: 10px;
        z-index: 100;
    }

    :global(.info.price) {
        padding: 20px 0px;
        border-top: 1px solid #9e9c9c;
        border-bottom: 1px solid #9e9c9c;
        line-height: 0px;
    }
</style>